import type { RouteRecordRaw } from 'vue-router'
import { AppModule } from '@/config/types'
import { getTasksBoardsRoutes } from '@/routes/user/tasks/tasksBoards'
import { TasksRoutes } from '@/routes/user/tasks/types'
import { getOldTasksSettingsRoute } from '@/routes/user/tasks/oldTasksSettings'

export const getTasksRoutes = (): RouteRecordRaw[] => [
  {
    name: TasksRoutes.index,
    path: 'tasks',
    props: true,
    meta: {
      tags: ['USER_TOP_MENU'],
      tabTitle: 'pageTitle.user.tasks.tasks',
      modules: [AppModule.TasksBase, AppModule.Tasks],
    },
    redirect: { name: TasksRoutes.base },
    component: () => import('@/components/views/tasks/Tasks.vue'),
    children: [...getTasksBoardsRoutes()],
  },
  getOldTasksSettingsRoute(),
]
